<template>
  <component
    :is="resolveLayoutVariant"
    :class="`skin-variant--${appSkinVariant}`"
  >
    <error-dialog />
    <loading-overlay
      :active="loading"
      loader="dots"
      :color="this.$vuetify.theme.isDark ? '#C3C3C3' : '#010B2E'"
      :width="250"
      :opacity="0.5"
      :background-color="this.$vuetify.theme.isDark ? '#000' : '#FFF'"
    ></loading-overlay>
    <transition
      :name="appRouteTransition"
      mode="out-in"
      appear
    >
      <router-view></router-view>
    </transition>
  </component>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { computed } from '@vue/composition-api'
// eslint-disable-next-line import/no-unresolved
import useAppConfig from '@core/@app-config/useAppConfig'
import { useRouter } from '@core/utils'
import { useLayout } from '@core/layouts/composable/useLayout'
import useDynamicVh from '@core/utils/useDynamicVh'
import LoadingOverlay from 'vue-loading-overlay'
import ErrorDialog from '@/components/dialogs/ErrorDialog.vue'
import store from '@/store'
import 'vue-loading-overlay/dist/vue-loading.css'

// Layouts
import LayoutContentVerticalNav from '@/layouts/variants/content/vertical-nav/LayoutContentVerticalNav.vue'
import LayoutBlank from '@/@core/layouts/variants/blank/LayoutBlank.vue'

export default {
  components: {
    LayoutContentVerticalNav,
    LayoutBlank,
    LoadingOverlay,
    ErrorDialog,
  },
  setup() {
    const { route } = useRouter()
    const { appContentLayoutNav, appSkinVariant, appRouteTransition } = useAppConfig()

    const { handleBreakpointLayoutSwitch } = useLayout()
    handleBreakpointLayoutSwitch()

    const resolveLayoutVariant = computed(() => {
      if (route.value.meta.layout === 'blank') return 'layout-blank'
      if (route.value.meta.layout === 'content') return `layout-content-${appContentLayoutNav.value}-nav`

      return null
    })

    const loading = computed(() => store.state.loader.loading)

    useDynamicVh()

    return {
      loading,
      resolveLayoutVariant,
      appSkinVariant,
      appRouteTransition,
    }
  },
}
</script>
<style>
.v-list-item--dense, .v-list--dense .v-list-item
{
  min-height: 10px !important;
}
</style>
